function processChildren(children) {
  const childrenToProcess = Array.isArray(children) ? [
    ...children
  ] : children ? [
    children
  ] : [];
  while (childrenToProcess.length) {
    const child = childrenToProcess.shift();
    if (!child)
      continue;
    if (Array.isArray(child)) {
      childrenToProcess.unshift(...child);
      continue;
    }
    const processor = componentRegistry.get(child.type);
    if (processor) {
      processor(child.props);
    } else {
      const anyChildren = Array.isArray(child.children) ? [
        ...child.children
      ] : [
        child.children
      ];
      childrenToProcess.unshift(...anyChildren);
    }
  }
}
const componentRegistry = /* @__PURE__ */ new Map();
function findComponent(component, processor) {
  componentRegistry.set(component, processor);
}
export {
  findComponent,
  processChildren
};
